import { createSelectionListViewContainer } from 'factories/SelectionListView'
import locationActions from 'actions/locations'
import Component from 'components/DraftOrder/SelectShipTo'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) => dispatch(locationActions.getAddressList({ type: 'shipTo', ...params })),
  }),
})(Component)
